import { Button } from '#/components/ui/button';
import { Link } from 'react-router';

import { DATA_AREAS } from '~/constants/data-areas';

import { buttonStyles } from '../styles';
import SvgImgError from '../svg/img-error';

export const SiteErrorBody = (props: { errorCode: string }) => {
  const { errorCode } = props;

  return (
    <div className="px-4 pt-6 pb-10" data-area={DATA_AREAS.SITE_ERROR_BODY}>
      <div className="flex flex-col">
        <h1 className="text-headline-m lg:text-headline-xl text-center">
          {errorCode === '404' ? (
            <>
              お探しのページが
              <br className="md:hidden" />
              見つかりませんでした
            </>
          ) : (
            <>
              ページが正しく
              <br className="md:hidden" />
              表示できませんでした
            </>
          )}
        </h1>

        <SvgImgError />
        <p className="text-body-m mb-6">
          {errorCode === '404' ? (
            <>お探しのページは、現在アクセスできない状態か、ページが存在しない可能性がございます。</>
          ) : (
            <>ご迷惑をおかけして申し訳ありません。ただいまページが正しく表示できませんでした。</>
          )}
          <br />
          <br />
          ブラウザの再読込みを行ってもこのページが表示される場合は、下記のリンクからトップページへお戻りください。
        </p>
        <Button asChild className={buttonStyles.default.lg}>
          <Link to={`/`}>トップページへ</Link>
        </Button>
      </div>
    </div>
  );
};
